import React from "react";
import {
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  SelectionMode,
} from "@fluentui/react/lib/DetailsList";
import { LeadSummary } from "./AdminStore";

interface LeadListProps {
  leads: LeadSummary[];
  onSelect: (lead: LeadSummary) => void;
}

export const LeadList: React.FunctionComponent<LeadListProps> = ({ leads, onSelect }) => {
  const columns: IColumn[] = [
    {
      key: "createdAt",
      name: "Date",
      minWidth: 160,
      maxWidth: 180,
      onRender: (item: LeadSummary) => new Date(item.createdAt).toLocaleString(),
    },
    {
      key: "name",
      name: "Name",
      minWidth: 140,
      maxWidth: 180,
      onRender: (item: LeadSummary) => `${item.firstName} ${item.lastName}`,
    },
    {
      key: "email",
      name: "Email",
      fieldName: "email",
      minWidth: 180,
      maxWidth: 240,
    },
    {
      key: "company",
      name: "Company",
      fieldName: "company",
      minWidth: 120,
      maxWidth: 180,
    },
    {
      key: "country",
      name: "Country",
      fieldName: "country",
      minWidth: 80,
      maxWidth: 120,
    },
    {
      key: "actionCount",
      name: "Actions",
      fieldName: "actionCount",
      minWidth: 80,
      maxWidth: 100,
    },
  ];

  return (
    <DetailsList
      items={leads}
      columns={columns}
      setKey="leads"
      layoutMode={DetailsListLayoutMode.justified}
      selectionMode={SelectionMode.none}
      onItemInvoked={(item) => onSelect(item as LeadSummary)}
    />
  );
};
